// 地区
export const enum Region {
  ID = 'ID',
  MY = 'MY',
  PH = 'PH',
  TH = 'TH',
  VN = 'VN',
  SG = 'SG',
  GB = 'GB',
  US = 'US',
  ES = 'ES',
  MX = 'MX',
  DE = 'DE',
  IT = 'IT',
  FR = 'FR',
  BR = 'BR',
  JP = 'JP',
  GLOBAL = ''
}

export function isValidRegion(region?: string): region is Region {
  if (region === undefined) {
    return false
  }

  return (
    [
      Region.ID,
      Region.MY,
      Region.PH,
      Region.TH,
      Region.VN,
      Region.SG,
      Region.GB,
      Region.US,
      Region.GLOBAL,
      Region.ES,
      Region.MX,
      Region.DE,
      Region.IT,
      Region.FR,
      Region.BR,
      Region.JP
    ] as string[]
  ).includes(region)
}
